import { CatchAwardClickBuilder } from '../../builders'
import { BaseController } from '../base.controller/base.controller'

export class RouletteAnalytics extends BaseController {
  /**
   * Клик по кнопке "Крути за бьютисы" в main
   */
  onCatchAwardClick() {
    this.send(CatchAwardClickBuilder, {})
  }
}
